<Modal
  title="Offer send successful"
  on:close={() => ($uiState.activeModal = undefined)}
  on:action={() => apply()}>
  The offer has been scheduled for sending. Emails will be sent within the hour.
</Modal>

<script lang="ts">
  import { uiState } from "../../../../../lib/uiState";
  import Modal from "../../../../_components/Modal.svelte";

  async function apply() {
    $uiState.activeModal = undefined;
  }
</script>
